import { DateTime } from "luxon";
// import { fromString } from "helpers/Date";

export function getRangeForDate(d1, d2) {
    // in luxon, weeks start on Monday

    let dtStart;
    let dtEnd;
    if (d1 === "now") {
        dtStart = DateTime.now().startOf("week").minus({ days: 1 });
        dtEnd = DateTime.now().endOf("week").minus({ days: 1 });
    } else if (typeof d1 === "object") {
        dtStart = d1;
        dtEnd = d2 ? d2 : d1.endOf("week").plus({ days: 6 }).endOf("day");
    }

    let current = dtStart;

    const range = [];
    while (current < dtEnd) {
        range.push(current);
        current = current.plus({ days: 1 });
    }

    return range;
}
